import { brand } from './brand';

/** Derive localStorage/sessionStorage key prefixes from brand config. */
const P = brand.storagePrefix;

// ── Core org/product context ──────────────────────────────────────
export const LS_ORG_ID = `${P}_org_id`;
export const LS_PRODUCT_ID = `${P}_product_id`;

// ── Support impersonation ─────────────────────────────────────────
export const LS_SUPPORT_STAFF_UID = `${P}_support_staff_uid`;
export const LS_SUPPORT_MODE = `${P}_support_mode`;
export const LS_SUPPORT_ROLE = `${P}_support_role`;
export const LS_SUPPORT_ORG_ID = `${P}_support_org_id`;
export const LS_SUPPORT_ORG_NAME = `${P}_support_org_name`;
export const LS_SUPPORT_ORG_SLUG = `${P}_support_org_slug`;
export const LS_SUPPORT_ORG_DISPLAY_NAME = `${P}_support_org_display_name`;
export const LS_ORIGINAL_ORG_ID = `${P}_original_org_id`;
export const LS_SUPPORT_HISTORY = `${P}_support_history`;

// ── Settings / UI state ───────────────────────────────────────────
export const LS_SETTINGS_SIDEBAR_COLLAPSED = `${P}_settings_sidebar_collapsed`;

// ── Releases ──────────────────────────────────────────────────────
export const LS_RELEASE_CALENDAR_COLLAPSED_YEARS = `${P}.releaseCalendar.collapsedYears`;
export const LS_RELEASE_ROADMAP_SELECTED_BOARD_IDS = `${P}.releaseRoadmap.selectedBoardIds`;
export const LS_RELEASE_ROADMAP_SELECTED_SPRINT_IDS = `${P}.releaseRoadmap.selectedSprintIds`;
export const LS_RELEASE_ROADMAP_SELECTED_RELEASE_ROW_IDS = `${P}.releaseRoadmap.selectedReleaseRowIds`;
export const LS_RELEASE_ROADMAP_USE_SAVED_FILTERS = `${P}.releaseRoadmap.useSavedFilters`;
export const LS_RELEASE_ROADMAP_DESELECT_ALL_SENTINEL = `__${P}_release_roadmap_deselect_all__`;

// ── Forecast ──────────────────────────────────────────────────────
/** Release / Sprint view selector on the Forecast page (RLX-FEAT-004). Hybrid removed. */
export const LS_FORECAST_VIEW_MODE = `${P}.forecast.viewMode`;

// ── Sprint plan ───────────────────────────────────────────────────
export const LS_SPRINT_PLAN_DEFAULT_BOARD_ID = `${P}.sprintPlan.defaultBoardId`;
export const LS_SPRINT_PLAN_ACTIVE_BOARD_ID = `${P}.sprintPlan.activeBoardId`;
export const DOM_EVENT_SPRINT_PLAN_BOARD = `${P}-sprint-plan-board`;

// ── Onboarding ────────────────────────────────────────────────────
export const LS_ONBOARDING_ACTIVE_ORG_ID = `${P}.onboarding.activeOrgId`;
export const LS_ONBOARDING_STEP_PREFIX = `${P}.onboarding.step.` as const;

// ── DOM custom events ─────────────────────────────────────────────
export const DOM_EVENT_ATLAS_MISSION_CHANGE = `${brand.eventPrefix}:atlasMissionChange`;
export const DOM_EVENT_WELCOME_TOUR_COMPLETED = `${brand.eventPrefix}:welcomeTourCompleted`;
